import * as React from 'react';

import {
  generateModelNamedGraph,
  getDefaultProjectModelPrefix,
} from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { useAddModelType } from 'src/containers/ProjectModelDialog/hooks/useAddModelTypeValue';
import { useImportModel } from 'src/containers/ProjectModelDialog/hooks/useImportModelValue';
import { useLocalModel } from 'src/containers/ProjectModelDialog/hooks/useLocalModelValue';
import { useUploadModel } from 'src/containers/ProjectModelDialog/hooks/useUploadModelValue';
import { projectSelector } from 'src/selectors/project';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useResetModelPanels = () => {
  const { projectId } = useRouterParams();
  const project = useReduxSelector(projectSelector(projectId));

  const { setAddModelType } = useAddModelType();
  const {
    setDatabaseId,
    setSelectedModels,
    setIsModelDataLoading: setIsImportModelDataLoading,
    setPendingModelData,
  } = useImportModel();
  const { setIsNameEdited, setIsNamespaceEdited, setName, setNamespace } =
    useLocalModel();
  const {
    setDatabaseId: setUploadDatabaseId,
    setFile,
    setIsModelDataLoading: setIsUploadModelDataLoading,
    setIsNameEdited: setIsUploadNameEdited,
    setIsNamedGraphIriEdited,
    setName: setUploadName,
    setNamedGraphIri,
    setPendingModelData: setUploadPendingModelData,
  } = useUploadModel();

  return React.useCallback(() => {
    const defaultNamespace = getDefaultProjectModelPrefix({
      name: project?.name || '',
    });
    setAddModelType(null);

    // import
    setDatabaseId('');
    setSelectedModels([]);
    setIsImportModelDataLoading(false);
    setPendingModelData({});

    // local
    setName(copy.components.projectModelDialog.localModelPanel.nameExampleText);
    setNamespace(defaultNamespace);
    setIsNameEdited(false);
    setIsNamespaceEdited(false);

    // upload
    setUploadDatabaseId('');
    setUploadName(
      copy.components.projectModelDialog.localModelPanel.nameExampleText
    );
    setNamedGraphIri(
      project ? generateModelNamedGraph(project, { name: 'example' }) : ''
    );
    setUploadPendingModelData(null);
    setFile(null);
    setIsUploadModelDataLoading(false);
    setIsUploadNameEdited(false);
    setIsNamedGraphIriEdited(false);
  }, [
    project,
    setAddModelType,
    setDatabaseId,
    setFile,
    setIsImportModelDataLoading,
    setIsNameEdited,
    setIsNamespaceEdited,
    setIsNamedGraphIriEdited,
    setIsUploadModelDataLoading,
    setIsUploadNameEdited,
    setName,
    setNamedGraphIri,
    setNamespace,
    setPendingModelData,
    setSelectedModels,
    setUploadDatabaseId,
    setUploadName,
    setUploadPendingModelData,
  ]);
};
